import React from 'react';
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import Request from '../../Models/Request';
import { SideBar } from '../Common/SideBar';
import ProductsUpload from '../../Models/ProductsUpload';
import { Header } from '../Common';
import Pagination from "react-js-pagination";
import {withTranslation} from "react-i18next";
class RequestHome extends React.Component {
    constructor(props) {
        super(props);
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            total: [],
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            user: '',
            request: [],
            product_name: '',
            category: '',
        };
        this.state.user = logged_user.id;
        this.getCategories();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        Request.getAll(1, this.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }
    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handlePageChange(pageNumber) {
        Request.getAll(pageNumber, this.state.user).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }

    requestButton() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div style={{ padding: "6%" }} className="" >
                    <div style={{ textAlign: "right", cursor: "pointer" }}>
                        <Link style={{ textDecoration: "none" }} to={'/request-bulletin'} href="">
                            <div className="use_request_button category-right " style={{ width: "100%", marginTop: "0px" }} >
                                <div className="seller_button shadow-text" style={{ padding: "2%", textAlign: "center" }} >
                                    {this.props.t('SELLER_REQUEST_BULLETIN.SELLER_REQUEST_BULLETIN_TITLE')}
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div style={{ padding: "6%", border: "1px solid #ddd" }} className="" >
                    <div style={{ textAlign: "right", cursor: "pointer" }}>
                        <Link style={{ textDecoration: "none" }} to={'/request-bulletin'} href="">
                            <div className="use_request_button category-right " style={{ width: "175px", marginTop: "0px", marginLeft: "33%" }} >
                                <div className="seller_button shadow-text" style={{ padding: "2%", textAlign: "center" }} >
                                    {this.props.t('SELLER_REQUEST_BULLETIN.SELLER_REQUEST_BULLETIN_TITLE')}
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            )
        }
    }

    pagination() {
        if (this.state.request < 10) {
            return (
                <div></div>
            )
        } else {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-6 ml-5">
                        <Pagination
                            hideNavigation
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.itemsCountPerPage}
                            totalItemsCount={this.state.total}
                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                            onChange={this.handlePageChange.bind(this)}
                        />
                    </div>
                    <div className="col-md-2"></div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%", fontSize: '20px' }}>
                                    {this.props.t('SELLER_REQUEST_BULLETIN.REQ_PROPOSAL')}
                                    </div>
                                <div style={{ minHeight: "300px", border: "1px solid #ddd", padding: "4%" }}>
                                    {this.requestButton()}
                                    {/* {(() => {
                                        if (this.state.request.length < 1) {
                                            return (
                                                <div></div>
                                            )
                                        } else {
                                            return (
                                                <div className="col-md-12 row" style={{ borderBottom: "1px solid #ddd", paddingTop: "3%", paddingBottom: "2%" }}>
                                                    <div className="col-md-5 font_12">
                                                        {this.props.t('SELLER_REQUEST_BULLETIN.CONSULTATION_CONTENT')}
                                                        </div>
                                                    <div className="col-md-2 font_12">
                                                        {this.props.t('SELLER_REQUEST_BULLETIN.PROPOSAL_DEADLINE')}
                                                        </div>
                                                    <div className="col-md-3 font_12">
                                                        {this.props.t('SELLER_REQUEST_BULLETIN.BUDGET')}
                                                        </div>
                                                    <div className="col-md-2 font_12">
                                                        {this.props.t('SELLER_REQUEST_BULLETIN.PROPOSALS')}
                                                        </div>
                                                </div>
                                            )
                                        }
                                    })()} */}
                                    {this.state.request.map((req, index) =>
                                        <div className="row" key={req.id} style={{ borderBottom: "1px solid #f4f2f0", paddingTop: "3%", paddingBottom: "2%" }}>
                                            <div className="col-md-5 pb-2 font_12">
                                                {(() => {
                                                    if (req.acceptance_status !== 'ACCEPTED') {
                                                        return (
                                                            <Link to={{
                                                                pathname: `/request-details/${req.id}`,
                                                                state:
                                                                {
                                                                    id: req.id,
                                                                    user: this.state.user,
                                                                }
                                                            }}>
                                                                <span className="blue_text" style={{ cursor: "pointer" }}>{req.title}</span>
                                                            </Link>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                            <div className="col-6 pb-2 font_12">
                                                {req.budget_range}{this.props.t('SELLER_REQUEST_BULLETIN.YEN')}
                                            </div>
                                            <div className="col-6 pb-2 font_12">
                                                {(JSON.stringify(req.application_date)).substring(1, 11)}
                                            </div>
                                            <div className="col-md-12 pb-2 font_12 ">
                                                <b>{this.props.t('SELLER_REQUEST_BULLETIN.PROPOSALS')} :</b> {req.number_of_proposals}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="request">

                                </div>
                            </div>
                        </div>
                        {this.pagination()}
                    </div >
                    <Footer />
                </div >
            )
        }
        //For Desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            {this.props.t('SELLER_REQUEST_BULLETIN.REQ_PROPOSAL')}
                                    </div>
                                        <div style={{ minHeight: "500px", border: "1px solid #ddd", padding: "4%" }}>
                                            {this.requestButton()}
                                            {/* <div style={{ padding: "6%", border: "1px solid #ddd" }} className="" >
                                            <div style={{ textAlign: "right", cursor: "pointer" }}>
                                                <Link style={{ textDecoration: "none" }} to={'/request-bulletin'} href="">
                                                    <div className="use_request_button category-right " style={{ width: "175px", marginTop: "0px", marginLeft: "33%" }} >
                                                        <div className="seller_button" style={{ padding: "2%", textAlign: "center" }} >
                                                            {this.props.t('SELLER_REQUEST_BULLETIN.SELLER_REQUEST_BULLETIN_TITLE')}
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div> */}
                                            {(() => {
                                                if (this.state.request.length < 1) {
                                                    return (
                                                        <div></div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="col-md-12 row" style={{ borderBottom: "1px solid #ddd", paddingTop: "3%", paddingBottom: "2%" }}>
                                                            <div className="col-md-5 font_12">
                                                                {this.props.t('SELLER_REQUEST_BULLETIN.CONSULTATION_CONTENT')}
                                                        </div>
                                                            <div className="col-md-2 font_12">
                                                                {this.props.t('SELLER_REQUEST_BULLETIN.PROPOSAL_DEADLINE')}
                                                        </div>
                                                            <div className="col-md-3 font_12">
                                                                {this.props.t('SELLER_REQUEST_BULLETIN.BUDGET')}
                                                        </div>
                                                            <div className="col-md-2 font_12">
                                                                {this.props.t('SELLER_REQUEST_BULLETIN.PROPOSALS')}
                                                        </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            {this.state.request.map((req, index) =>
                                                <div className="col-md-12 row" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                                    <div className="col-md-5 font_12">
                                                        {/* <span className="font_12">リクエスト No: {++i}</span><br /> */}
                                                        {(() => {
                                                            if (req.acceptance_status !== 'ACCEPTED') {
                                                                return (
                                                                    <Link to={{
                                                                        pathname: `/request-details/${req.id}`,
                                                                        state:
                                                                        {
                                                                            id: req.id,
                                                                            user: this.state.user,
                                                                        }
                                                                    }}>
                                                                        <span className="blue_text" style={{ cursor: "pointer" }}>{req.title}</span>
                                                                    </Link>
                                                                )
                                                            }
                                                            // else {
                                                            //     return (
                                                            //         <Link to={{
                                                            //             pathname: `/request-details-from-bulletin/${req.id}`,
                                                            //             state:
                                                            //             {
                                                            //                 id: req.id,
                                                            //                 user: this.state.user,
                                                            //             }
                                                            //         }}>
                                                            //             <span className="blue_text" style={{ cursor: "pointer" }}>{req.title}</span>
                                                            //         </Link>
                                                            //     )
                                                            // }
                                                        })()}
                                                    </div>
                                                    <div className="col-md-2 font_12">
                                                        {(JSON.stringify(req.application_date)).substring(1, 11)}
                                                        {/* {req.application_date} */}
                                                    </div>
                                                    <div className="col-md-3 font_12">
                                                        <b>{req.budget_range}{this.props.t('SELLER_REQUEST_BULLETIN.YEN')}</b>
                                                    </div>
                                                    <div className="col-md-2 font_12 ">
                                                        <b>{req.number_of_proposals}</b>
                                                    </div>
                                                </div>
                                            )}

                                        </div>


                                        <div className="request">
                                            {/* <div className="col-md-12 row">
                                            <div className="col-md-6 input_name big_font guide_text" style={{ padding: "2%", textAlign: "left" }}>
                                                <span style={{ fontSize: "20px" }}><b><i>{this.props.t('SELLER_REQUEST_BULLETIN.REQ_PROPOSAL')}</i></b></span>
                                            </div>
                                            <div className="col-md-6 input_name big_font guide_text" style={{ padding: "2%", textAlign: "right" }}>
                                                <Link to={{
                                                    pathname: `/request-bulletin`
                                                }}>
                                                    <button
                                                        style={{ fontSize: "15px", padding: "3%", borderRadius: "5px", color: "green", backgroundColor: "white" }}>
                                                        {this.props.t('SELLER_REQUEST_BULLETIN.SELLER_REQUEST_BULLETIN_TITLE')}
                                                    </button>
                                                </Link>
                                            </div>
                                        </div> */}

                                            {/* <div className="mini_padding" style={{ height: "auto" }}>
                                            <div className="card" style={{ border: '0px solid' }}>
                                                <div className="row  px-3">
                                                    {this.state.request.map((group, index) =>
                                                        <div className="mini_padding inner-div" style={{ width: "100%" }} key={index}>
                                                            <div className="mini_padding hover_div">
                                                                <div className="row">
                                                                    <div className="col-md-4 card-body">
                                                                        <div className="card-title">
                                                                            {(() => {
                                                                                if (group.acceptance_status !== 'ACCEPTED') {
                                                                                    return (
                                                                                        <Link to={{
                                                                                            pathname: `/request-details/${group.id}`,
                                                                                            state:
                                                                                            {
                                                                                                id: group.id,
                                                                                                user: this.state.user,
                                                                                            }
                                                                                        }}>
                                                                                            <span className="blue_text" style={{ cursor: "pointer" }}>{group.title}</span>
                                                                                        </Link>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        <Link to={{
                                                                                            pathname: `/request-details-from-bulletin/${group.id}`,
                                                                                            state:
                                                                                            {
                                                                                                id: group.id,
                                                                                                user: this.state.user,
                                                                                            }
                                                                                        }}>
                                                                                            <span className="blue_text" style={{ cursor: "pointer" }}>{group.title}</span>
                                                                                        </Link>
                                                                                    )
                                                                                }
                                                                            })()}

                                                                        </div>
                                                                        <div className="card-text">
                                                                            {group.content.substring(1, 30)}...
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-8 card-body">
                                                                        <table style={{ height: "86px" }}>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="vline text-center" style={{ borderRight: "0px solid" }}><b>予算目安 </b><br /><br />{group.budget_range} 円</td>
                                                                                    <td className="vline text-center" style={{ borderRight: "0px solid" }}><b>{this.props.t('SELLER_REQUEST_BULLETIN.PROPOSAL_DEADLINE')}</b><br /><br />{(JSON.stringify(group.application_date)).substring(1, 11)}</td>
                                                                                    <td className="vline text-center"><b>{this.props.t('SELLER_REQUEST_BULLETIN.PROPOSALS')}</b><br /><br />{group.number_of_proposals}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </div> */}
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}
                            </div>
                        </div>
                    </div >
                    <Footer />
                </div >
            )
        }
    }
}
export { RequestHome }
RequestHome = withTranslation('seller')(RequestHome);
